module.exports = "<h1 id=\"走马灯--m-carousel\">走马灯  m-carousel</h1>\n";